import { render, staticRenderFns } from "./AccountAdd.vue?vue&type=template&id=51a31fd4&"
import script from "./AccountAdd.vue?vue&type=script&lang=js&"
export * from "./AccountAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports